import { Injectable, Injector } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from '../_services/toastr.service';

const RATE_LIMIT_MESSAGE = /troppe richieste|troppi tentativi|too many requests|rate.?limit/i;
const RATE_LIMIT_CODES = ['rate-limited', 'rate_limited', 'too_many_requests', 'too-many-requests'];
export const DEFAULT_RATE_LIMIT_MESSAGE = 'Troppe richieste. Riprova tra poco.';

/** Message of a rate-limit error (HTTP 429 or a GraphQL/Action error), or null if it is not one. */
export function rateLimitMessage(error: any): string | null {
  if (!error) return null;
  if (error instanceof HttpErrorResponse) {
    if (error.status !== 429) return null;
    return error.error?.message || error.error?.errors?.[0]?.message || DEFAULT_RATE_LIMIT_MESSAGE;
  }
  const status = error.extensions?.['status'] ?? error.extensions?.['statusCode'];
  const code = String(error.extensions?.['code'] || '').toLowerCase();
  const message = String(error.message || '');
  if (status === 429 || RATE_LIMIT_CODES.includes(code) || RATE_LIMIT_MESSAGE.test(message)) {
    return message || DEFAULT_RATE_LIMIT_MESSAGE;
  }
  return null;
}

/** Shows the rate-limit message to the user, at most once every few seconds. Never retries. */
@Injectable({ providedIn: 'root' })
export class RateLimitNotifier {
  private lastShownAt = 0;

  // ToastrService is resolved lazily: this is used from an HTTP interceptor.
  constructor(private injector: Injector) {}

  /** Returns true (and notifies) when the error is a rate-limit error. */
  handle(error: any): boolean {
    const message = rateLimitMessage(error);
    if (!message) return false;
    if (Date.now() - this.lastShownAt > 5000) {
      this.lastShownAt = Date.now();
      this.injector.get(ToastrService).warning('Attendi un momento', message);
    }
    return true;
  }
}
